// extracted by mini-css-extract-plugin
module.exports = {"main-component":"drive_main-component__2X84I"};